<div class="d-flex justify-content-center">
    <div>
        @for(sideCompetitor of getCompetitors(HomeSide); track sideCompetitor){
            @let team = getTeam(sideCompetitor);
            @if(team){
                <span>
                    @if(isTeamCompetitor(sideCompetitor)) {
                        <app-team-name [team]="team" [reverse]="true">
                        </app-team-name>
                    }
                    @if(!isTeamCompetitor(sideCompetitor) && isCompetitor(sideCompetitor)) {
                        <span></span>
                    }
                </span>
            }
        }
    </div>

    <div class="px-2" title="{{dateFormatter.toString(againstGame().getStartDateTime(),dateFormatter.date())}} {{dateFormatter.toString(againstGame().getStartDateTime(),dateFormatter.time())}}">{{nameService.getAgainstScore(againstGame())}}</div>

    <div>
        @for(sideCompetitor of getCompetitors(AwaySide); track sideCompetitor){
            @let team = getTeam(sideCompetitor);
            @if(team){
                <span>
                    @if(isTeamCompetitor(sideCompetitor)) {
                        <app-team-name [team]="team"></app-team-name>
                    }
                    @if(!isTeamCompetitor(sideCompetitor) && isCompetitor(sideCompetitor)) {
                        <span></span>
                    }
                </span>
            }
        }
    </div>

    @if(showDate() && showFinishedDate()) {
        <div class="ps-3 "
            ngClass="{'text-decoration-line-through': againstGame().getState() === Finished}">
            {{dateFormatter.toString(againstGame().getStartDateTime(),dateFormatter.date())}}
            @if(againstGame().getState() !== Finished) {
                <span>{{dateFormatter.toString(againstGame().getStartDateTime(),
                    dateFormatter.time())}}</span>
            }
        </div>
    }

</div>